import * as cartApi from '../../helpers/cartApi';

const selectors = {
  crossSell: '[data-cart-cross-sell]',
  crossSellItem: '[data-cross-sell-item]',
  form: '[data-cross-sell-form]',
  swatchLabel: '[data-swatch-label]',
};

/**
 * The wrapper class for Cross Sells
 *
 * @export
 * @class CartCrossSell
 */
export default class CartCrossSell {
  constructor(el, cartItems, updateCart) {
    this.el = el.querySelector(selectors.crossSell);
    this.updateCart = updateCart;
    this.cartItems = cartItems;
    this.currentIndex = 0;

    this._init();
  }

  _init = () => {
    this._iterateCartItems();
  };

  _attachListeners = () => {
    const form = this.el.querySelector(selectors.form);
    form.addEventListener('submit', this._onSubmit);

    const swatchLabels = this.el.querySelectorAll(selectors.swatchLabel);
    swatchLabels.forEach(label => {
      label.addEventListener('click', this._onChange);
    });
  };

  _onChange = event => {
    event.preventDefault();
    const label = event.target.closest(selectors.swatchLabel);
    const input = document.getElementById(label?.getAttribute('for'));

    if (!input) return;

    const form = this.el.querySelector(selectors.form);
    const variantId = input.getAttribute('data-variant-id');

    if (variantId) {
      this._fetchProductHtml(
        form.dataset.productHandle,
        `&variant=${variantId}`,
      );
    }
  };

  _onSubmit = event => {
    event.preventDefault();

    const formData = Object.fromEntries(new FormData(event.target));

    const data = {
      ...formData,
    };

    // loop over formdata and if key starts with properties, add to properties object
    Object.keys(formData).forEach(key => {
      if (key.startsWith('properties')) {
        data.properties = data.properties || {};
        data.properties[key.replace('properties[', '').replace(']', '')] =
          formData[key];
        delete data[key];
      }
    });

    cartApi.add({ items: [data] }).then(res => {
      if (res.sections) {
        this.updateCart({ sections: res.sections });
      }
    });
  };

  _iterateCartItems = () => {
    // loop over cart items and get the product ID from the dataset and map them into an array
    const productIds = Array.from(this.cartItems).map(
      item => item.dataset.productId,
    );

    this._fetchComplementaryProducts(productIds);
  };

  _fetchComplementaryProducts = async productIds => {
    const productId = await fetch(
      `${Shopify.routes.root}recommendations/products.json?section_id=main-cart-cross-sell&product_id=${productIds[this.currentIndex]}&limit=1&intent=complementary`,
    );
    const productIdJson = await productId.json();
    if (productIdJson.products?.length > 0) {
      this._fetchProductHtml(productIdJson.products[0].handle);
    } else {
      this.currentIndex += 1;
      if (this.currentIndex < productIds.length) {
        this._fetchComplementaryProducts(productIds);
      }
    }
  };

  _fetchProductHtml = async (handle, params = '') => {
    const response = await fetch(
      `${Shopify.routes.root}products/${handle}?section_id=main-cart-cross-sell${params}`,
    );
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const crossSellItem = html.querySelector(selectors.crossSellItem);
    this.el.innerHTML = crossSellItem.innerHTML;

    this._attachListeners();
  };
}
